import React from 'react';
import { Link } from 'react-router-dom';
import { mockScientists } from '../services/dataService';
import { getScientistImage } from '../utils/imageUtils';

/**
 * Scientist List Page Component
 */
const ScientistList = () => {
  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        👨‍🔬 Scientists
      </h1>
      <div className="grid">
        {mockScientists.map(scientist => (
          <div key={scientist.id} className="card">
            <img 
              src={getScientistImage(scientist.id, scientist.name)} 
              alt={scientist.name}
              style={{ 
                width: '100%', 
                height: '300px', 
                objectFit: 'cover', 
                borderRadius: '8px', 
                marginBottom: '15px' 
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {scientist.name}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Field:</strong> {scientist.field}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Country:</strong> {scientist.country}
            </p>
            <p style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>
              {scientist.biography.substring(0, 150)}...
            </p>
            <Link to={`/scientists/${scientist.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              View Profile
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScientistList;
